import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { MultiCollapsibleList } from '../../../../../components';
import { fetchAnswers } from '../../../../../stores/actions/alternatives';
import { isNullOrEmptyArray } from '../../../../../util/arrays';
import { getSafe } from '../../../../../util/verification/verifyUndefined';

function QuestionCollapsibleList({
  /**
   * Define o id do usuario
   */
  customerId,
  /**
   * Define se o item todos selecionados sera exibido
   */
  withAllSelected = false,
  /**
   * Define se o item todos selecionados sera exibido
   */
  listType,
  /**
   * Propaga o evento de quando o item é selecionado
   */
  onSelect,
  /**
   * Propaga o evento de quando o selectAll é selecionado
   */
  onSelectAll,
  /**
   * array que é percorrido para exibição dos itens colapsáveis
   */
  datas,
  /**
   * array de Itens selecionados
   */
  internalSelectedIds,
  /**
   * Define se o item allSelect esta ativo
   */
  allItemsSelected,
  /**
   * Define se a seta ira aparecer
   */
  withArrow = true,
  ...props
}) {
  // from redux
  const { alternatives, error, dispatch } = props;
  const [internalData, setInternalData] = useState(datas);
  // const [loading, setIsLoading] = useState(false);
  // const [error, setError] = useState(false);

  // state
  const [surveyId, setSurveyId] = useState(null);
  const [questionId, setQuestionId] = useState(null);
  const [expandedItemIndex, setExpandedItemIndex] = useState(null);

  // efeito de atualização das alternativas
  useEffect(() => {
    const key = { customerId, surveyId, questionId };
    const alternativesByKey = alternatives.get(key);
    if (alternativesByKey) {
      if (!isNullOrEmptyArray(alternativesByKey.payload)) {
        const data = alternativesByKey.payload.map((a) => ({
          value: a.id,
          label: a.enunciado,
        }));
        if (!getSafe(() => internalData[expandedItemIndex].datas)) {
          internalData[expandedItemIndex] = { ...internalData[expandedItemIndex], data };
        }
      }
    }
  }, [alternatives, customerId, internalData, expandedItemIndex, questionId, surveyId]);

  // No caso de haver erro depois que solicitar salvar
  useEffect(() => {
    if (error) {
      toast.error(error.toString());
    }
  }, [error]);

  function mapDatasToInternalData(internalDatas) {
    const asInternalData = internalDatas.map((data) => ({
      ...data,
      value: `${data.value.surveyId}-${data.value.questionId}`,
    }));
    return asInternalData;
  }

  useEffect(() => {
    const asInternalData = mapDatasToInternalData(datas);
    setInternalData(asInternalData);
  }, [datas]);


  const handleExpandCallback = useCallback((item, index) => {
    const [sId, qId] = item.value.split('-');
    setSurveyId(sId);
    setQuestionId(qId);
    setExpandedItemIndex(index);
    fetchAnswers({ customerId, surveyId: Number(sId), questionId: Number(qId) }, dispatch);
  }, [customerId]);

  const handleSelectAllCallback = useCallback((sel, checked) => {
    if (onSelectAll) onSelectAll(sel, checked);
  }, [onSelectAll]);

  const handleOnSelectCallback = useCallback((...innerProps) => {
    if (onSelect) onSelect(...innerProps);
  }, [onSelect]);

  return (
    <MultiCollapsibleList
      datas={internalData}
      onSelect={handleOnSelectCallback}
      onExpand={handleExpandCallback}
      onSelectAll={handleSelectAllCallback}
      withAllSelected={withAllSelected}
      setActiveItems
      //      expansible
      allItemsSelected={allItemsSelected}
      withArrow={withArrow}
    />
  );
}

/**
 * Mapeia o estado da store para as propriedades que serão passadas para este
 * componente.
 *
 * O estado é "alternatives" que é um mapa de dados cuja chave é o questionId.
 *
 * @param {*} state
 * @param {*} props
 */
const mapStateToProps = (state) => {
  const alternativesState = state.alternatives;
  // if exists
  return {
    alternatives: alternativesState || [],
  };
};


// create component (delegate) and export
export default connect(
  mapStateToProps, null, null, { forwardRef: false },
)(QuestionCollapsibleList);
